import { render, staticRenderFns } from "./BTN003n_diagonal_ right.vue?vue&type=template&id=50f82036&scoped=true&"
import script from "./BTN003n_diagonal_ right.vue?vue&type=script&lang=js&"
export * from "./BTN003n_diagonal_ right.vue?vue&type=script&lang=js&"
import style0 from "./BTN003n_diagonal_ right.vue?vue&type=style&index=0&id=50f82036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f82036",
  null
  
)

export default component.exports